// set function parseTime,formatTime to filter
export { parseTime, formatTime } from "@/utils";
import { isEmpty } from "@/utils";
import dateUtil from "@/utils/format_date.js";
import numeral from "numeral";
import dayjs from "dayjs";
import Config from "@/config";
import * as RongYun from "@/utils/rongyun";

export function chatTimeFormat(value) {
  if (!value) return "";
  let date = new Date(value);
  let currentDate = new Date();
  if (
    Math.abs(currentDate.getTime() - date.getTime()) < 1000 * 3600 * 24 &&
    Math.abs(currentDate.getDate() - date.getDate()) <= 0
  ) {
    date = dateUtil.getFormatDate2(date, "hh:mm:ss"); /* yymmddhhmmss */
    return date;
  } else if (Math.abs(currentDate.getFullYear() - date.getFullYear()) <= 0) {
    return dateUtil.getFormatDate2(date, "MM-dd hh:mm:ss");
  } else {
    return dateUtil.getFormatDate2(date, "yyyy-MM-dd hh:mm:ss");
  }
}

export function chatFormateDate(value) {
  return RongYun.chatFormateDate(value);
}

export function ymdhmsFormat(value) {
  let date = new Date(value);
  return dateUtil.getFormatDate2(date, "yyyy-MM-dd hh:mm:ss");
}

function pluralize(time, label) {
  if (time === 1) {
    return time + label;
  }
  return time + label + "s";
}

export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time);
  if (between < 3600) {
    return pluralize(~~(between / 60), " minute");
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), " hour");
  } else {
    return pluralize(~~(between / 86400), " day");
  }
}
export function periodNoFilter(value, len) {
  if (!value) return;
  return value.slice(len);
}

/* 数字 格式化*/
export function numberFormatter(num, digits) {
  const si = [
    {
      value: 1e18,
      symbol: "E"
    },
    {
      value: 1e15,
      symbol: "P"
    },
    {
      value: 1e12,
      symbol: "T"
    },
    {
      value: 1e9,
      symbol: "G"
    },
    {
      value: 1e6,
      symbol: "M"
    },
    {
      value: 1e3,
      symbol: "k"
    }
  ];
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value + 0.1)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, "$1") + si[i].symbol
      );
    }
  }
  return num.toString();
}

export function toThousandFilter(num) {
  return (+num || 0)
    .toString()
    .replace(/^-?\d+/g, m => m.replace(/(?=(?!\b)(\d{3})+$)/g, ","));
}

export function keepDecimalOf2(val) {
  return val ? numeral(Number(val)).format("0.00", Math.floor) : "0.00";
}

export function oddsFormate(val) {
  if (!val) return "0.00";
  val = String(val);
  const dot = val.split(".")[1];
  // if (!dot || dot.length <= 2) {
  return numeral(Number(val)).format("0.00", Math.floor);
  // }
  // return numeral(Number(val)).format("0.000", Math.floor);
}

export function hideRealName(val) {
  if (!val) return "";
  let name = val.split("");
  let str = "";
  for (let i = 0; i < name.length; i++) {
    if (i !== name.length - 1) {
      str += "*";
    } else {
      str += name[i];
    }
  }

  return str;
}
export function hideBankNo(value) {
  if (!value) return "";
  return (
    value.slice(0, 4) +
    value.slice(4, value.length - 4).replace(/\d/g, "*") +
    value.slice(value.length - 4)
  );
  // if (/\S{5}/.test(value) && value) {
  //   value = value.replace(/\s/g, "").replace(/(.{4})/g, "$1 ");
  // }
  // let val = value.split(" ");
  // let str = "";
  // for (let i = 0; i < val.length; i++) {
  //   if (i > 0 && i < val.length - 1) {
  //     str += "**** ";
  //   } else {
  //     str += val[i] + " ";
  //   }
  // }
  // return str;
}
export function hidePhone(value) {
  if (!value) return "";
  return value.slice(0, 3) + "****" + value.slice(7, 12);
}
export function sliceLastStrByNum(val, num = 5) {
  const len = `${val}`.length;
  let ret = "";
  if (isEmpty(val)) {
    ret = val;
  } else {
    ret = `${val}`.slice(len - num, len);
  }
  return ret;
}

export function formatMoney(val = 0, fstr = `0,0.00`, fmethod = Math.floor) {
  return numeral(val).format(fstr, fmethod);
}

export function addZero2UnitsDigit(val = 0, startVal = 0) {
  const value = val + startVal;
  return value < 10 ? `0${value}` : `${value}`;
}

export function addMoneySymbols(val = 0) {
  let money = numeral(val).value() || 0;
  if (money > 0) {
    money = `+${money}`;
  } else if (money === 0) {
    money = "0";
  } else {
    money = `-${money}`;
  }
  return money;
}
// 后台返回的时间无论时间戳还是格式时间都需要经过处理
export function convert2LocalDateTime(value, format) {
  if (!value) {
    return;
  }
  const iValue = Number(value);
  if (Number.isInteger(iValue)) {
    return dayjs(iValue).format(format || Config.dateTimeFormat);
  }
  return dayjs(value)
    .tz(Config.timezone, true)
    .tz()
    .format(format || Config.dateTimeFormat);
}
// 转换本地时间到服务器默认东8区
export function convert2ServerDateTime(value, enabled = false, format) {
  if (!value) {
    return;
  }
  if (!enabled) {
    return dayjs(value).format(format || Config.dateTimeFormat);
  }
  const iValue = Number(value);
  if (Number.isInteger(iValue)) {
    value = iValue;
  }
  //   return dayjs(value).tz(Config.timezone).format(fromat || Config.dateTimeFormat)
  // }
  // 转换本地日期到服务器默认东8区
  // export function convert2ServerDate(value, enabled = false) {
  //   if (!value) {
  //     return
  //   }
  //   if (!enabled) {
  //     return dayjs(value).format(Config.dateFormat);
  //   }
  //   const iValue = Number(value);
  //   if (Number.isInteger(iValue)) {
  //     value = iValue;
  //   }
  return dayjs(value)
    .tz(Config.timezone)
    .format(format || Config.dateTimeFormat);
}

export function convert2OfficialMoney(localMoney, rate) {
  const exchangeRate = rate || 1;
  const money = localMoney || 0;
  return numeral(money)
    .multiply(exchangeRate)
    .format("0.00");
}
